import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { AppModuleGlobalShared } from '../../../app.module.global';
import { PaginatorModule } from 'primeng/paginator';
import { EnvioAduanaV3ListComponent } from './enviosaduanasv3/envioaduanav3-list.component';
import { EnvioTracesListComponent } from './enviostraces/enviotraces-list.component';
import { EnvioEphytoListComponent } from './enviosephyto/envioephyto-list.component';
import { EnvioDocumentoTracesListComponent } from './documentostraces/enviodocumentotraces-list.component';
import { EnvioAduanasEditComponent } from './enviosaduanas/envioaduana-edit.component';
import { EnvioAduanasV3EditComponent } from './enviosaduanasv3/envioaduanav3-edit.component';
import { EnvioTracesEditComponent } from './enviostraces/enviotraces-edit.component';
import { EnvioEphytoEditComponent } from './enviosephyto/envioephyto-edit.component';
import { EnvioDocumentoTracesEditComponent } from './documentostraces/enviodocumentotraces-edit.component';
import { EnvioAduanaListComponent } from './enviosaduanas/envioaduana-list.component';
import { EnvioAduanasService } from './enviosaduanas/envioaduana.service';
import { EnvioAduanasV3Service } from './enviosaduanasv3/envioaduanav3.service';
import { EnvioTracesService } from './enviostraces/enviotraces.service';
import { EnvioEphytoService } from './enviosephyto/envioephyto.service';
import { EnvioDocumentoTracesService } from './documentostraces/enviodocumentotraces.service';
import { CalendarModule } from 'primeng/calendar';
import { EnviosRoutingModule } from './envios-routing.module';
import { SeriLogWrapperComponent } from './serilog/serilog-wrapper/serilog-wrapper.component';
import { SeriLogFilterComponent } from './serilog/serilog-filter/serilog-filter.component';
import { SeriLogListComponent } from './serilog/serilog-list/serilog-list.component';
import { SeriLogWrapperEditComponent } from './serilog/serilog-wrapper-edit/serilog-wrapper-edit.component';
import { SeriLogEditComponent } from './serilog/serilog-edit/serilog-edit.component';
import { TwSeriLogService } from './serilog/serilog.service';

@NgModule({
    declarations: [
        EnvioAduanaListComponent,
        EnvioAduanaV3ListComponent,
        EnvioTracesListComponent,
        EnvioEphytoListComponent,
        EnvioDocumentoTracesListComponent,
        EnvioAduanasEditComponent,
        EnvioAduanasV3EditComponent,
        EnvioTracesEditComponent,
        EnvioEphytoEditComponent,
        EnvioDocumentoTracesEditComponent,
        SeriLogWrapperComponent,
        SeriLogFilterComponent,
        SeriLogListComponent,
        SeriLogWrapperEditComponent,
        SeriLogEditComponent,
    ],
    imports: [CoreModule, AppModuleGlobalShared, PaginatorModule, CommonModule, FormsModule, ReactiveFormsModule, CalendarModule, EnviosRoutingModule],
    providers: [EnvioAduanasService, EnvioAduanasV3Service, EnvioTracesService, EnvioEphytoService, EnvioDocumentoTracesService, TwSeriLogService],
})
export class EnviosModule {}
